import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';

import { SR_API_ACTION_BUYER_SIDE_AGENT_SIGNUP } from 'api/actionTypes';

import { USER_ROLE_BUYER_SIDE_AGENT } from 'common/userRoles';

import allowedRoles, { getUserLandingPage } from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withLocationQuery from 'client/helpers/withLocationQuery';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withApiState from 'client/helpers/withApiState';

import branch from 'client/core/branch';

import SrText from 'client/components/SrText';
import SrBuyerSideAgentFormPage from 'client/components/SrBuyerSideAgentFormPage/SrBuyerSideAgentFormPage';

const getFormFields = () => {
  const formFields = [
    {
      id: 'clientName',
      type: 'short_text',
      validations: ['required'],
      properties: {
        placeholder: 'Client’s full name',
      },
    },
    {
      id: 'clientEmail',
      type: 'email',
      validations: ['required', 'email'],
      properties: {
        placeholder: 'Client’s email',
      },
    },
    {
      id: 'clientPhone',
      type: 'phone',
      validations: ['required', 'phone'],
      properties: {
        placeholder: 'Client’s phone number',
      },
    },
  ];
  return formFields;
};

@withTransitionHook
@withScrollToTop
@withLocationQuery
@allowedRoles({
  roles: [USER_ROLE_BUYER_SIDE_AGENT],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withApiState({
  buyerSideAgentSignupApiState: {
    action: SR_API_ACTION_BUYER_SIDE_AGENT_SIGNUP,
  },
})
@branch({
  currentUser: ['currentUser'],
})
class SelfTourClientInfoPage extends React.Component {
  static getPageMetadata = () => ({
    pageTitle: 'Self Tour | Sunroom Rentals',
  });

  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    buyerSideAgentSignupApiState: PropTypes.object.isRequired,
  };

  _onSubmit = (formValues) => {
    const { match, history } = this.props;

    history.push(
      `/listing/${match.params.listingId}?${queryString.stringify({
        ...formValues,
        showSelfShowingSteps: true,
      })}`,
    );
  };

  render() {
    const { currentUser, buyerSideAgentSignupApiState } = this.props;

    if (!currentUser.roles.includes(USER_ROLE_BUYER_SIDE_AGENT)) {
      return (
        <Redirect
          to={getUserLandingPage({
            userRoles: currentUser.roles,
          })}
        />
      );
    }

    const formFields = getFormFields();

    return (
      <SrBuyerSideAgentFormPage
        pageTitle="Who is the client that you’re touring with?"
        pageDescription={
          <>
            <SrText weight="700" color="grey">
              To be eligible for commission:
            </SrText>
            <br />
            The first time your client(s) tour the property you must unlock the door for them. If
            there are multiple clients applying together, we only need the info of one.
          </>
        }
        formFields={formFields}
        apiState={buyerSideAgentSignupApiState}
        onSubmit={this._onSubmit}
      />
    );
  }
}

SelfTourClientInfoPage.displayName = 'SelfTourClientInfoPage';

export default SelfTourClientInfoPage;
